import { lazy } from 'react';

import { authRoles } from 'app/auth';

const UsersPage = lazy(() => import('./UsersPage'));
const InviteUserPage = lazy(() => import('./invite/InviteUserPage'));
const EditUserPage = lazy(() => import('./edit/EditUserPage'));

// The invite and edit screens work on the organisation carried in the URL from the Users
// page, so the header keeps the back link but not the organisation selector.
const withoutOrganisationSelector = {
  layout: {
    config: {
      healtheraHeader: { display: true, options: { organisationSelector: false } },
    },
  },
};

const UsersConfig = {
  settings: {
    layout: {
      config: {
        footer: { display: false },
        healtheraHeader: {
          display: true,
          options: { organisationSelector: true },
        },
      },
    },
  },
  auth: authRoles.pharmacyAdmin,
  routes: [
    { path: 'users', element: <UsersPage /> },
    { path: 'users/invite', element: <InviteUserPage />, settings: withoutOrganisationSelector },
    {
      path: 'users/:userId/edit',
      element: <EditUserPage />,
      settings: withoutOrganisationSelector,
    },
  ],
};

export default UsersConfig;
